import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "./index.css";

import React, { useState } from "react";
import { Button } from "primereact/button";
import "./FormDemo.css";
import { InputText } from "primereact/inputtext";
import {
  appsIcons,
  brandProfile,
  getBrandLocale,
  getStoreUser,
  getWarehouseUser,
  signIn,
  userProfile,
} from "../services/SignIn";
import { removeUserData, setSelectedDocsSchedule, setStoreLocalData, setUserData } from "../utils/localStorage";
import { clearToken, setToken } from "../redux/authSlice";
import { errorMessage } from "../utils/alertMessage";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Alert } from "bootstrap";
import { useEffect } from "react";
import { STORE_BASE_URL } from "../services/BaseURL";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [hostProfileData, setHostProfileData] = useState({});

  useEffect(() => {
    const getHostProfile = async () => {
      try {
        const storedData = localStorage.getItem("hostProfile");

        // if (storedData) {
        //   setHostProfileData(JSON.parse(storedData));
        //   return;
        // }

        // API call if local storage data not found
        const response = await fetch(
          STORE_BASE_URL + "/brand/api/external/v1/host-profile"
        );

        const data = await response.json();

        const profile = data.data || data;

        // store in local storage
        localStorage.setItem(
          "hostProfile",
          JSON.stringify(profile)
        );

        // set state
        setHostProfileData(profile);

      } catch (error) {
        console.log("host profile error", error);
      }
    };


    getHostProfile();

  }, []);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useDispatch();

  const [input, setInput] = useState({
    user: "",
    pass: "",
  });

  const handleUserName = inputValue => {
    const copyNumber = inputValue.replace(/^\s*|\s+/g, "");
    setInput({
      ...input,
      user: copyNumber,
    });
  }

  const handlePassword = inputValue => {
    const copyNumber = inputValue.replace(/^\s*|\s+/g, "");
    setInput({
      ...input,
      pass: copyNumber,
    });
  }

  const [isFormSubmit, setIsFormSubmit] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsFormSubmit(true);
    try {

      const loginAllowedTo = hostProfileData?.otherInfoList?.loginAllowedTo;

      // check only when loginAllowedTo is not ANY
      if (
        loginAllowedTo &&
        loginAllowedTo !== "ANY" &&
        !input.user.startsWith(loginAllowedTo)
      ) {
        setIsFormSubmit(false);
        errorMessage("Not-Allowed");
        return;
      }

      const response = await signIn({
        username: input.user,
        password: input.pass,
        source: "web",
        version: "2.1",
      });
      if (response && response.data && !response.data.error) {
        const token = response.data.accessToken;
        const userResponse = await userProfile(token);

        if (userResponse && userResponse.data && !userResponse.data.error) {
          const userProfileData = userResponse.data;
          let userProfileRole = "";
          if (userProfileData.role === "ROLE_STORE") {
            userProfileRole = "BY_STORE";
            await setSelectedDocsSchedule("yes");
          } else if (userProfileData.role === "ROLE_ADMIN") {
            userProfileRole = "BY_ADMIN";
            await setSelectedDocsSchedule("");
          } else if (userProfileData.role === "ROLE_SUPPORT_ADMIN") {
            userProfileRole = "BY_SUPPORT_ADMIN";
            await setSelectedDocsSchedule("");
          } else if (userProfileData.role === "ROLE_ACCOUNTANT") {
            userProfileRole = "BY_ACCOUNTANT";
            await setSelectedDocsSchedule("");
          } else if (userProfileData.role === "ROLE_SUB_ADMIN_USER") {
            userProfileRole = "BY_SUB_ADMIN_USER";
            await setSelectedDocsSchedule("");
          } else if (userProfileData.role === "ROLE_WAREHOUSE") {
            userProfileRole = "BY_WAREHOUSE";
            await setSelectedDocsSchedule("");
          } else if (userProfileData.role === "ROLE_FRANCHISE_ADMIN") {
            userProfileRole = "BY_FRANCHISE_ADMIN";
            await setSelectedDocsSchedule("");
          } else {
            userProfileRole = "";
          }
          // const userProfileRole = userProfileData.role;
          if (
            ![
              "ROLE_STORE",
              "ROLE_ADMIN",
              "ROLE_SUPPORT_ADMIN",
              "ROLE_ACCOUNTANT",
              "ROLE_SUB_ADMIN_USER",
              "ROLE_WAREHOUSE",
              "ROLE_FRANCHISE_ADMIN",
            ].includes(userProfileData.role)
          ) {
            removeUserData();
            dispatch(clearToken());
            setIsFormSubmit(false);
            Alert.alert("Hello User", "You don't have a access");
          } else if (
            ["ROLE_STORE", "ROLE_WAREHOUSE"].includes(userProfileData.role) &&
            userProfileData.mapped !== true
          ) {
            removeUserData();
            dispatch(clearToken());
            setIsFormSubmit(false);
            Alert.alert("Hello User,", "Please Contact Your Administrator.");
          } else {
            // if (["ROLE_STORE", "ROLE_ADMIN", "ROLE_WAREHOUSE"].includes(userProfileRole)) {
            const brandResponse = await brandProfile(token);

            if (
              brandResponse &&
              brandResponse.data &&
              !brandResponse.data.error
            ) {
              const brandProfileData = brandResponse.data;
              let storeData = {};
              let storeLocalData = {};
              let warehouseData = {};
              let garmentCategoryServiceIconsResData = {};

              const garmentCategoryServiceIconsRes = await appsIcons(token);

              if (
                garmentCategoryServiceIconsRes &&
                !garmentCategoryServiceIconsRes.data.error
              ) {
                garmentCategoryServiceIconsResData =
                  garmentCategoryServiceIconsRes.data;
              } else {
                console.error("Error fetching store user");
              }

              if (userProfileData.role !== "ROLE_STORE") {
                const brandLocaleResponse = await getBrandLocale(
                  // const storeResponse = await getStore(
                  brandProfileData?.localeId,
                  token
                );
                if (brandLocaleResponse && !brandLocaleResponse.data.error) {
                  storeLocalData = brandLocaleResponse.data;
                } else {
                  console.error("Error fetching store user");
                }
              }

              if (userProfileData.role === "ROLE_STORE") {
                const storeResponse = await getStoreUser(
                  // const storeResponse = await getStore(
                  userProfileData.id,
                  token
                );
                if (storeResponse && !storeResponse.data.error) {
                  storeData = storeResponse.data.store;
                  storeLocalData = storeResponse.data.store?.localeDTO;
                } else {
                  console.error("Error fetching store user");
                }
              } else if (userProfileData.role === "ROLE_WAREHOUSE") {
                const warehouseResponse = await getWarehouseUser(
                  userProfileData.id,
                  token
                );
                if (warehouseResponse && !warehouseResponse.data.error) {
                  warehouseData = warehouseResponse.data;
                } else {
                  console.error("Error fetching warehouse user");
                }
              }
              setUserData({
                token,
                userProfileRole,
                userProfileData,
                brandProfileData,
                storeData,
                warehouseData,
                garmentCategoryServiceIconsResData,
              });
              setStoreLocalData(storeLocalData)
              dispatch(setToken(token));
              setIsFormSubmit(false);
            } else {
              console.error("Error fetching brand profile");
              setIsFormSubmit(false);
            }
          }
        } else {
          console.error("Error fetching user profile");
          setIsFormSubmit(false);
        }
      } else {
        console.error("Error:", response?.data?.message || "Unknown error");
        setIsFormSubmit(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setIsFormSubmit(false);
      errorMessage();
    }
  };

  // const [isDesktop, setIsDesktop] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  // useEffect(() => {
  //   // Check if the user is on a mobile device
  //   const checkIfMobile = () => /Mobi|Android/i.test(navigator.userAgent);
  //    if (checkIfMobile()) {
  //      // Redirect to Play Store link for mobile users
  //      window.location.href =
  //        "https://play.google.com/store/apps/details?id=com.dhobicartV2";
  //    } else {
  //     setIsDesktop(true);
  //    }
  // }, []);

  return (
    <div className="login-container flex-one">
      {Object.keys(hostProfileData).length > 0 && <div className="login-section flex-one">
        {isDesktop ? (
          <div className="flex-1 flex justify-content-center align-items-center">
            <img
              style={{ width: "330px" }}
              src={hostProfileData?.logoURI || "/dhobicart.jpeg"}
              alt="logo"
            />
          </div>
        ) : (
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <img
              style={{ width: "330px" }}
              src={hostProfileData?.logoURI || "/dhobicart.jpeg"}
              alt="logo"
            />

            <h1>This site is only accessible on desktop devices.</h1>
            <p>Please switch to a desktop device to continue.</p>
          </div>
        )}
        {isDesktop && (
          <div className="flex-1 flex justify-content-center align-items-center">
            <div className="p-fluid">
              <div className="field">
                <div className="input-group has-validation">
                  <InputText
                    value={input.user}
                    onChange={(e) => handleUserName(e.target.value)}
                    type="text"
                    name="username"
                    className="p-inputtext-lg"
                    id="username"
                    placeholder="UserName"
                  />
                </div>
              </div>

              <div className="field">
                <div className="input-group has-validation">
                  <InputText
                    value={input.pass}
                    onChange={(e) => handlePassword(e.target.value)}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="p-inputtext-lg"
                    id="password"
                    placeholder="Password"
                  />
                  {/* Move the eye icon inside the input box */}
                  <span
                    className="input-group-addon"
                    onClick={handleTogglePassword}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                      left: "-10px",
                      marginLeft: "-15px",
                    }}
                  >
                    <i
                      className={`pi ${!showPassword ? "pi-eye-slash" : "pi-eye"
                        }`}
                    />
                  </span>
                </div>
              </div>
              <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                <p>
                  For better privacy. Use a private browsing window to Login.
                </p>
              </div>

              {!isFormSubmit ? (
                <Button
                  onClick={(e) => handleSubmit(e)}
                  label="Login"
                  className="mt-2"
                  style={{
                    float: "right",
                    backgroundColor: "#0b57d0",
                    borderRadius: 30,
                    width: "25vh",
                  }}
                />
              ) : (
                <Button
                  onClick={() => console.log("nothing")}
                  label="Please Wait"
                  className="mt-2"
                  style={{
                    float: "right",
                    backgroundColor: "#6fa3f7ff",
                    borderRadius: 30,
                    width: "25vh",
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>}
      {Object.keys(hostProfileData).length > 0 && <div

        className="bottom-card-div flex-class">
        <div className="social-media-div flex-class">
          {hostProfileData?.otherInfoList?.youtubeLink &&
            <Link
              to={hostProfileData?.otherInfoList?.youtubeLink}
              target="_blank"
            >
              <i
                className="pi pi-youtube"
                style={{ fontSize: "2rem", color: "red", cursor: "pointer" }}
              ></i>
            </Link>}
          {hostProfileData?.otherInfoList?.instagramLink &&
            <Link to={hostProfileData?.otherInfoList?.instagramLink} target="_blank">
              <i
                className="pi pi-instagram"
                style={{ fontSize: "2rem", color: "#d62976", cursor: "pointer" }}
              ></i>
            </Link>
          }
          {hostProfileData?.otherInfoList?.linkedinLink &&
            <Link
              to={hostProfileData?.otherInfoList?.linkedinLink}
              target="_blank"
            >
              <i
                className="pi pi-linkedin"
                style={{ fontSize: "2rem", color: "#0072b1", cursor: "pointer" }}
              ></i>
            </Link>
          }
          {hostProfileData?.otherInfoList?.facebookLink &&
            <Link to={hostProfileData?.otherInfoList?.facebookLink} target="_blank">
              <i
                className="pi pi-facebook"
                style={{ fontSize: "2rem", color: "#1877F2", cursor: "pointer" }}
              ></i>
            </Link>}
          {hostProfileData?.otherInfoList?.androidLink &&
            <Link
              to={hostProfileData?.otherInfoList?.androidLink}
              target="_blank"
            >
              <i
                className="pi pi-android"
                style={{ fontSize: "2rem", color: "#a4c639", cursor: "pointer" }}
              ></i>
            </Link>}
          {hostProfileData?.otherInfoList?.phone &&
            <Link to={`tel: ${hostProfileData?.otherInfoList?.phone}`} target="_blank">
              <i
                className="pi pi-phone"
                style={{
                  fontSize: "2rem",
                  color: "#1877F2",
                  cursor: "pointer",
                }}
              ></i>
            </Link>}
        </div>
        <div className="flex-class privacy-div">
          {hostProfileData?.otherInfoList?.aboutUs && <Link
            to={hostProfileData?.otherInfoList?.aboutUs}
            target="_blank"
            style={{
              color: "#0066a6",
              fontSize: 14,
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            About Us
          </Link>}
          {hostProfileData?.otherInfoList?.privacyPolicyLink && <Link
            to={hostProfileData?.otherInfoList?.privacyPolicyLink}
            target="_blank"
            style={{
              color: "#0066a6",
              fontSize: 14,
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            Privacy Policy
          </Link>}
          {hostProfileData?.otherInfoList?.termConditionLink && <Link
            to={hostProfileData?.otherInfoList?.termConditionLink}
            target="_blank"
            style={{
              color: "#0066a6",
              fontSize: 14,
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            Term & Condition
          </Link>}
          {hostProfileData?.otherInfoList?.refundCancellationPolicy && <Link
            to={hostProfileData?.otherInfoList?.refundCancellationPolicy}
            target="_blank"
            style={{
              color: "#0066a6",
              fontSize: 14,
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            Refund & Cancellation Policy
          </Link>}
          {hostProfileData?.otherInfoList?.currentVersion && <p
            style={{
              color: "#0066a6",
              fontSize: 14,
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            {hostProfileData?.otherInfoList?.currentVersion}
          </p>}
        </div>
      </div>}

      {Object.keys(hostProfileData).length > 0 && hostProfileData?.otherInfoList?.address && <div

        className=" flex-class">
        <div>
          <p style={{
            fontSize: 13,
            fontWeight: "600",
            color: "#475467",
            textAlign: "center",
          }}> Register Address: {hostProfileData?.otherInfoList?.address}</p>
        </div>
      </div>}
    </div>
  );
};

export default Login;
